import React, { Component } from 'react';

class FormicaToggleSwitch extends Component<Props> {
  render() {
    const { value = false, onChange, disabled, large } = this.props;
    const widthClass = large ? `w-[42px]` : 'w-[22px]';
    const heightClass = large ? `h-[22px]` : 'h-[12px]';
    const afterWidthClass = large ? `after:w-[20px]` : 'after:w-[10px]';
    const afterHeightClass = large ? `after:h-[20px]` : 'after:h-[10px]';

    return (
      <label className='relative inline-flex items-center cursor-pointer'>
        <input
          disabled={disabled}
          type='checkbox'
          value=''
          checked={value}
          onChange={(e: any) => onChange(e)}
          className='sr-only peer'
          data-testid={this.props['data-testid']}
        />
        <div
          className={`${widthClass} ${heightClass} ${afterWidthClass} ${afterHeightClass} bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[1px] after:left-[1px] after:bg-white after:border-gray-300 after:border after:rounded-full after:transition-all dark:border-gray-600 peer-checked:bg-primary`}
        />
      </label>
    );
  }
}

interface Props {
  value: boolean;
  onChange: (e: any) => void;
  disabled?: boolean;
  large?: boolean;
  'data-testid'?: string;
}

export default FormicaToggleSwitch;
